import { useStyles } from './ToolsGroupDivider.styles';

export const ToolsGroupDivider = () => {
  const classes = useStyles();

  return <div className={classes.root} />;
};
